import { IEnquesta } from 'bg-server/src/components/api/v1/enquesta/types';
import { IExpedient } from 'bg-server/src/components/api/v1/expedient/types';

import { ENV } from 'src/config/environments';
import { httpRequest } from 'src/helpers/http';
import { IAddEnquestaData } from 'src/interfaces';

class EnquestaService {
    private getApiEndpoint(): string {
        const selectedCity = localStorage.getItem('selectedCity') || ENV.apiEndpoints[0].key;
        const apiEndpoint = ENV.apiEndpoints.find(endpoint => endpoint.key === selectedCity);
        return apiEndpoint ? `${apiEndpoint.url}` : `${ENV.apiEndpoints[0].url}`;
    }

    public async addExpedientEnquesta(expedientId: string, formVersion: number, formType: string, preguntes: { [key: string]: string }): Promise<IExpedient> {
        const data: IAddEnquestaData = {
            formVersion,
            formType,
            preguntes,
            expedient: expedientId,
        };
        const response = await httpRequest(`${this.getApiEndpoint()}/expedient/${expedientId}/enquesta`, 'POST', data);
        const json = await response.json();
        if (json.error !== undefined) {
            await Promise.reject(json.message);
        }
        return json;
    }

    public async getEnquestesByExpedientId(expedientId: string): Promise<IEnquesta[]> {
        const response = await httpRequest(`${this.getApiEndpoint()}/expedient/${expedientId}/enquesta`, 'GET');
        const json = await response.json();
        if (json.error !== undefined) {
            await Promise.reject(json.message);
        }
        return json;
    }

    public async getExpedientEnquesta(expedientId: string, enquestaId: string): Promise<IEnquesta> {
        const response = await httpRequest(`${this.getApiEndpoint()}/expedient/${expedientId}/enquesta/${enquestaId}`, 'GET');
        const json = await response.json();
        if (json.error !== undefined) {
            await Promise.reject(json.message);
        }
        return json;
    }
}

export const enquestaService = new EnquestaService();
